import httpClient from '@/global/httpClient';
import * as apis from '@/constants/api';

export * from '@/scripts/Exercise/Exercise.service';

export const getPzFilterData = bookId =>
  httpClient.get(`${apis.GET_READER_CENTER_PZ_FILTER_DATA}/${bookId}`);
export const getQuestionList = payload =>
  httpClient.post(apis.GET_READER_CENTER_QUESTION_LIST, { ...payload });
export const answer = payload =>
  httpClient.post(apis.POST_READER_CENTER_QUESTION_ANSWER, { ...payload }, { ignore: true });
